<template>
  <div class="influencer-detail">
    <div class="bread-crumb">
      Influencers Detail
    </div>
    <h2>Influencers Detail</h2>
    <a-spin :spinning="isLoading" class="loading">
      <div class="basic-info" v-if="detail">{{ detail.id }}&nbsp;&nbsp;|&nbsp;&nbsp;{{ detail.name
      }}&nbsp;&nbsp;|&nbsp;&nbsp;{{ detail.email }}</div>
      <a-tabs v-model:activeKey="activeKey" @change="onTabChange">
        <a-tab-pane key="1" tab="Basic Info">
          <div class="content" v-if="detail">
            <div class="info section">
              <h3>User Infomation</h3>
              <div class="flex-row">
                <span>UserID: {{ detail.id }}</span>
                <span>Apply Time:
                  {{ moment(detail.applyTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                <span v-if="detail.updateTime">Update Time:
                  {{
                    moment(detail.updateTime).format('YYYY-MM-DD HH:mm:ss')
                  }}</span>
                <span v-if="detail.registeredTime">Registered Time:
                  {{
                    moment(detail.registeredTime).format('YYYY-MM-DD HH:mm:ss')
                  }}</span>
              </div>
              <a-row :gutter="[40, 20]">
                <a-col :span="12">
                  <label>Email*</label>
                  <a-input class="fixed-width" type="text" :value="detail.email" @blur="checkEmail" />
                  <div class="error-tip" v-if="emailErrorTip.length">
                    {{ emailErrorTip }}
                  </div>
                </a-col>
                <a-col :span="12">
                  <label>Gender</label>
                  <a-select class="fixed-width" v-model:value="detail.gender" :options="[
                    { value: 'Man' },
                    { value: 'Woman' },
                    { value: 'Secret' },
                  ]"></a-select>
                </a-col>
                <a-col :span="12">
                  <label>Username*</label>
                  <a-input class="fixed-width" type="text" :maxLength="100" v-model:value="detail.userName"
                    @keyup="(e) => checkName(e.target.value.trim(), 'username')"
                    @blur="(e) => checkName(e.target.value.trim(), 'username')" />
                  <div class="error-tip" v-if="userNameErrorTip.length">
                    {{ userNameErrorTip }}
                  </div>
                </a-col>
                <a-col :span="12">
                  <label>Date of Birth</label>
                  <a-date-picker class="fixed-width" v-model:value="birthday" :defaultPickerValue="defaultDate"
                    placeholder="Pick a Date" />
                </a-col>
                <a-col :span="12">
                  <label>Name*</label>
                  <a-input type="text" class="fixed-width" :maxLength="100" v-model:value="detail.name"
                    @keyup="(e) => checkName(e.target.value.trim(), 'name')"
                    @blur="(e) => checkName(e.target.value.trim(), 'name')" />
                  <div class="error-tip" v-if="nameErrorTip.length">
                    {{ nameErrorTip }}
                  </div>
                </a-col>
                <a-col :span="12">
                  <label>Content Category</label>
                  <a-select class="fixed-width" v-model:value="selectedContentCategory.name"
                    placeholder="Select Content Category" :options="contentCategories"
                    @change="setSelectedContentCategory" />
                </a-col>
                <a-col :span="12">
                  <label>Phone Number</label>
                  <div class="flex-wrapper fixed-width">
                    <a-select class="phone-area-code-select" :style="{ width: '80px' }"
                      v-model:value="countryCallingCode.phoneCode" :dropdown-match-select-width="false"
                      :options="phoneAreaCodeList" @select="phoneCodeChange" />
                    <a-input type="text" v-model:value="detail.phoneNum" @keyup="handlePhoneNumInput" />
                  </div>
                </a-col>
                <a-col :span="12">
                  <label>Largest Social Audience</label>
                  <a-select class="fixed-width" placeholder="Select Largest Social Audience" :options="socialPlatforms"
                    v-model:value="selectedLargestSocialAudience.id" />
                </a-col>
                <a-col :span="12">
                  <label>Primary Audience Region</label>
                  <a-select class="fixed-width" placeholder="Select Primary Audience Region" :options="audienceRegions"
                    v-model:value="selectedPrimaryAudienceRegion.id"></a-select>
                </a-col>
              </a-row>
            </div>
            <div class="social-platform section">
              <h3>Social Platform</h3>
              <a-row :gutter="[40, 20]">
                <a-col :span="12" class="selected-platform-item" v-for="(platform, index) in addedSocialPlatforms"
                  :key="index">
                  <label>{{ platform.platformName }}</label>
                  <a-input class="fixed-width" v-model:value="platform.homepage" type="text"
                    :placeholder="getHomepagePlaceholder(platform)"
                    :maxLength="1000"></a-input>
                  <MinusCircleOutlined v-if="addedSocialPlatforms.length > 1" @click="deleteSocialPlatform(index)" />
                </a-col>
                <a-col :span="12" class="selected-platform">
                  <a-select class="fixed-width" v-model:value="selectedSocialPlatform" :options="socialPlatforms"
                    placeholder="+ Select to Add Other Platform" @select="socialPlatformAdded" />
                </a-col>
              </a-row>
              <a-row :gutter="[40, 20]">
                <a-col :span="12">
                  <label>Note</label>
                  <a-textarea class="fixed-width" v-model:value="detail.note" :maxLength="1000"
                    :auto-size="{ minRows: 4, maxRows: 4 }" />
                </a-col>
              </a-row>
            </div>
            <div class="section">
              <a-row :gutter="[40, 20]">
                <a-col :span="12" class="operator-mark">
                  <label>Operator Mark<em class="tip">Invisible to the influencer</em></label>
                  <a-textarea class="fixed-width" v-model:value="detail.operatorRemark"
                    :auto-size="{ minRows: 4, maxRows: 4 }" :maxLength="1000" type="text" />
                </a-col>
              </a-row>
              <a-row :gutter="[40, 20]">
                <a-col :span="12" class="authority">
                  <label>Authority</label>
                  <div class="fixed-width">
                    <label>Link Tool</label>
                    <a-switch v-model:checked="detail.linkToolStatus" checked-children="ON" un-checked-children="OFF"
                      @click="toggleStatus" />
                    <label>Log in</label>
                    <a-switch v-model:checked="detail.logInStatus" checked-children="ON" un-checked-children="OFF"
                      @click="toggleStatus" />
                  </div>
                </a-col>
              </a-row>
              <a-row :gutter="[40, 20]" v-if="detail.advertiserWhiteList">
                <a-col :span="12" class="advertiser-whitelist">
                  <label>Advertiser Whitelist</label>
                  <a-select disabled class="fixed-width" v-model:value="whiteList" mode="tags" />
                </a-col>
              </a-row>
              <a-row :gutter="[40, 20]">
                <a-col :span="12">
                  <div class="btns fixed-width">
                    <a-button type="primary" @click="save">Save Changes</a-button>
                    <a href="#/influencers/registered"><a-button>Cancel</a-button></a>
                  </div>
                </a-col>
              </a-row>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="Payment Info">
          <div class="content payment-info-content" v-if="detail">
            <div class="section payment-section">
              <h3>Account</h3>
              <a-table v-if="paymentAccounts.length" :columns="paymentColumns" :data-source="paymentAccounts"
                :pagination="false" row-key="id" size="middle" bordered :scroll="{ x: 980 }"
                class="payment-accounts-table">
                <template #bodyCell="{ column, record, text }">
                  <template v-if="column.key === 'account'">
                    <span :class="'payment-account-text' + record.status.toLowerCase()"
                      :title="String(record.account ?? text ?? '')">{{ record.account
                        ?? text }}</span>
                  </template>
                  <template v-else-if="column.key === 'action'">
                    <a-switch checked-children="ON" un-checked-children="OFF" :checked="record.status === 'Active'"
                      @change="(checked) => onPaymentSwitchChange(record, checked ? 'Active' : 'Inactive')" />
                  </template>
                  <template v-else-if="column.key === 'remark'">
                    <a-input v-model:value="record.operatorRemark" placeholder="Remark: Click to enter"
                      @blur="onPaymentRemarkBlur(record)" />
                  </template>
                </template>
              </a-table>
              <p class="empty-text" v-else>No content has been submitted yet.</p>
            </div>
            <div class="section payment-section tax-section">
              <h3>Tax Information</h3>
              <div class="tax-info-card" v-if="paymentTaxInfo.length && paymentTaxInfo[0]">
                <div class="tax-info-tin-row">
                  <span class="tax-info-label">Taxpayer Identification Number (TIN):</span>
                  <span class="tax-info-tin-value">{{
                    paymentTaxInfo[0].taxayerIdentificationNumber || '—'
                  }}</span>
                </div>
                <div class="tax-info-form-row">
                  <span class="tax-info-label tax-form-label-inline">
                    <em class="required">*</em>Tax Form:
                  </span>
                  <div class="tax-form-link-wrap">
                    <a v-if="paymentTaxInfo[0].taxpayerFileUrl" :href="paymentTaxInfo[0].taxpayerFileUrl"
                      target="_blank" rel="noopener noreferrer" class="tax-form-link">{{
                        paymentTaxInfo[0].taxpayerFileName || 'Tax form'
                      }}</a>
                    <span v-else class="tax-form-empty">—</span>
                  </div>
                </div>
              </div>
              <p class="empty-text" v-else>No content has been submitted yet.</p>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { message, Modal } from 'ant-design-vue'
import { MinusCircleOutlined } from '@ant-design/icons-vue'

import { influencers } from '../../server/index'
import moment from 'moment'

const route = useRoute()
const isLoading = ref(false)
const defaultDate = moment('2000-01-01 00:00:00')
const activeKey = ref(route.query.s == 'p' ? '2' : '1')

const paymentColumns = [
  { title: 'Type', dataIndex: 'type', key: 'type', width: 110 },
  {
    title: 'Account',
    dataIndex: 'account',
    key: 'account',
    width: 340,
    minWidth: 280,
    ellipsis: false,
  },
  { title: 'Status', dataIndex: 'status', key: 'status', width: 96 },
  { title: 'Action', key: 'action', width: 100 },
  { title: 'Operator Remark', key: 'remark', width: 280, ellipsis: true },
]

const paymentAccounts = ref([])
/** 每项: id, Status, taxpayerFileName, taxpayerFileUrl, taxayerIdentificationNumber */
const paymentTaxInfo = ref([])

function onTabChange(key) {
  activeKey.value = key
}

function toggleStatus() {
  /* Authority switches：随 Save Changes 一并提交 */
}

function normalizeTaxInfoRow(raw, index, influencerId) {
  const id = raw.id ?? `tax-${influencerId}-${index}`
  const Status = raw.Status ?? raw.status ?? ''
  const taxpayerFileName = raw.taxpayerFileName ?? raw.taxFormName ?? ''
  const taxpayerFileUrl =
    raw.taxpayerFileUrl ?? raw.taxFormUrl ?? raw.taxFormLink ?? ''
  let taxayerIdentificationNumber =
    raw.taxayerIdentificationNumber ?? raw.taxpayerIdentificationNumber
  if (taxayerIdentificationNumber == null || taxayerIdentificationNumber === '') {
    const tinType = raw.taxTinType ?? raw.tinType
    const tinMasked = raw.taxTinMasked ?? raw.tinMasked
    if (tinType || tinMasked) {
      taxayerIdentificationNumber = `${tinType ?? ''}${tinMasked != null && tinMasked !== '' ? ` (${tinMasked})` : ''
        }`.trim()
    } else {
      taxayerIdentificationNumber = ''
    }
  }
  return {
    id,
    Status,
    taxpayerFileName,
    taxpayerFileUrl,
    taxayerIdentificationNumber,
  }
}

/** 独立接口覆盖列表中的 Payment / Tax */
function loadPaymentAndTaxFromApi(influencerId) {
  if (influencerId == null || influencerId === '') return
  influencers.getPaymentAccounts(influencerId).then((res) => {
    if (res.success && Array.isArray(res.data) && res.data.length) {
      paymentAccounts.value = res.data.map((row, i) => ({
        id: row.id ?? `acc-${influencerId}-${i}`,
        type: row.type ?? 'PayPal',
        account: row.account ?? '',
        status:
          row.status ?? (row.active === false ? 'Inactive' : 'Active'),
        active: row.active !== false,
        operatorRemark: row.operatorRemark ?? '',
      }))
    }
  })
  influencers.getTaxInfo(influencerId).then((res) => {
    if (res.success && res.data) {
      const list = Array.isArray(res.data) ? res.data : [res.data]
      if (list.length) {
        const rows = list.map((t, i) =>
          normalizeTaxInfoRow(t, i, influencerId)
        )
        paymentTaxInfo.value = [rows[0]]
      }
    }
  })
}

function persistPaymentAccount(record) {
  if (!detail.value?.id) return Promise.resolve({ success: false })
  return influencers
    .setRemark(detail.value.id, record.id, record.operatorRemark)
    .then((res) => {
      if (res.success) {
        message.success('Updated.')
      } else {
        message.error(res.message || 'Request failed')
      }
    })
    .catch(() => {
      message.error('Network error')
      return { success: false }
    })
}

function onPaymentSwitchChange(record, status) {
  if (status === 'Active') {
    record.active = true
    record.status = 'Active'
    influencers.togglePaymentAccount(detail.value.id, record.id, true).then((res) => {
      if (res.success) {
        message.success('Updated.')
      } else {
        message.error(res.message || 'Request failed')
      }
    }).catch(() => {
      message.error('Network error')
      record.active = false
      record.status = 'Inactive'
    })
  } else {
    Modal.confirm({
      title: 'Are you sure to disable this payment method?',
      okText: 'Yes',
      cancelText: 'No',
      okType: 'primary',
      centered: true,
      async onOk() {
        record.active = false
        record.status = 'Inactive'
        influencers.togglePaymentAccount(detail.value.id, record.id, false).then((res) => {
          if (res.success) {
            message.success('Updated.')
          } else {
            message.error(res.message || 'Request failed')
          }
        }).catch(() => {
          message.error('Network error')
          record.active = true
          record.status = 'Active'
        })
      }
    });
  }
}

function onPaymentRemarkBlur(record) {
  persistPaymentAccount(record)
}
const detail = ref(null)
const birthday = ref(null)
const audienceRegions = ref([])
const socialPlatforms = ref([])

function getPlatformKey(platform) {
  return String(
    platform?.platformName || platform?.name || platform?.label || ''
  )
    .trim()
    .toLowerCase()
    .replace(/\.$/, '')
}

const HOMEPAGE_PLACEHOLDER_MAP = {
  instagram: 'e.g. www.instagram.com/xxx',
  youtube: 'e.g. www.youtube.com/@xxx',
  linktree: 'e.g. linktr.ee/xxx',
  facebook: 'e.g. www.facebook.com/xxx',
  x: 'e.g. x.com/xxx',
  twitter: 'e.g. x.com/xxx',
  tiktok: 'e.g. www.tiktok.com/@xxx',
  red: 'e.g. xhslink.com/xxx',
  xiaohongshu: 'e.g. xhslink.com/xxx',
  wechat: 'wechat username',
  weibo: 'e.g. weibo.com/xxx',
  blog: 'Please fill in URL',
  website: 'Please fill in URL',
  others: 'Please fill in URL',
  other: 'Please fill in URL',
}

const HOMEPAGE_DOMAIN_MAP = {
  instagram: ['instagram.com'],
  youtube: ['youtube.com'],
  linktree: ['linktr.ee'],
  facebook: ['facebook.com'],
  x: ['x.com'],
  twitter: ['x.com'],
  tiktok: ['tiktok.com'],
  red: ['xhslink.com', 'xhslink.cn'],
  xiaohongshu: ['xhslink.com', 'xhslink.cn'],
  weibo: ['weibo.com'],
}
const HOMEPAGE_URL_FORMAT_KEYS = new Set(['blog', 'website', 'others', 'other'])
const HOMEPAGE_SKIP_VALIDATE_KEYS = new Set(['wechat'])

function isValidUrlFormat(val) {
  const input = String(val).trim().replace(/^https?:\/\//i, '')
  return /^[\w-]+(\.[\w-]+)+([/?#][^\s]*)?$/i.test(input)
}

function getHomepagePlaceholder(platform) {
  const name = getPlatformKey(platform)
  if (!name) return 'URL or Username'
  return HOMEPAGE_PLACEHOLDER_MAP[name] || 'Please fill in URL'
}

function getHomepageValidationHelp(val, platform) {
  const key = getPlatformKey(platform)
  if (!key || HOMEPAGE_SKIP_VALIDATE_KEYS.has(key)) return ''

  const domains = HOMEPAGE_DOMAIN_MAP[key]
  if (domains) {
    const lower = String(val).toLowerCase()
    if (!domains.some((domain) => lower.includes(domain))) {
      return `Homepage domain must match ${domains.join(' / ')}`
    }
    return ''
  }

  if (HOMEPAGE_URL_FORMAT_KEYS.has(key) && !isValidUrlFormat(val)) {
    return 'Please enter a valid URL'
  }

  return ''
}

const contentCategories = ref([])
const phoneAreaCodeList = ref([])
const selectedContentCategory = ref({
  id: null,
  name: undefined,
})
const selectedLargestSocialAudience = ref({
  id: null,
  name: undefined,
})
const selectedPrimaryAudienceRegion = ref({
  id: null,
  name: undefined,
})
const whiteList = ref([])
const countryCallingCode = ref({ phoneCode: '+1' })
const addedSocialPlatforms = ref([])
const selectedSocialPlatform = ref(undefined)

const nameErrorTip = ref('')
const emailErrorTip = ref('')
const userNameErrorTip = ref('')

influencers.getDetail(route.params.id).then((res) => {
  if (res.success) {
    if (res.data) {
      const callingCode = res.data.countryCallingCode

      if (callingCode) {
        countryCallingCode.value = {
          ...callingCode,
          phoneCode: '+' + callingCode.phoneCode,
        }
      }

      if (!res.data.name.trim().length) {
        nameErrorTip.value = 'Name is required.'
      }

      if (!res.data.userName.trim().length) {
        userNameErrorTip.value = 'Username is required.'
      }

      if (!res.data.email.trim().length) {
        emailErrorTip.value = 'Email is required.'
      }

      if (
        !/^[\w\d.-]+@[\w\d-]+(?:\.[\w\d-]+)+$/.test(res.data.email?.trim())
      ) {
        emailErrorTip.value = 'Invalid email, please check again.'
      }

      if (res.data.socialPlatforms) {
        addedSocialPlatforms.value = res.data.socialPlatforms
      }

      if (res.data.contentCategory) {
        selectedContentCategory.value = res.data.contentCategory
      }

      if (res.data.largestSocialAudience) {
        selectedLargestSocialAudience.value = res.data.largestSocialAudience
      }

      if (res.data.primaryAudienceRegion) {
        selectedPrimaryAudienceRegion.value = res.data.primaryAudienceRegion
      }

      if (res.data.advertiserWhiteList) {
        whiteList.value = res.data.advertiserWhiteList.map((item) => {
          return {
            ...item,
            value: item.advertiserName,
            label: item.advertiserName,
          }
        })
      }

      detail.value = res.data
      // initPaymentFromDetail(res.data)
      loadPaymentAndTaxFromApi(res.data.id)

      if (res.data.birthday) {
        birthday.value = moment(res.data.birthday)
      }
    } else {
      location.href = location.href.replace(/#[\w\W]*$/, '#/404')
    }
  }

  isLoading.value = false
})
  ;[
    { action: 'getAudienceRegion', param: audienceRegions },
    { action: 'getSocialPlatformsList', param: socialPlatforms },
    { action: 'getContentCategoryList', param: contentCategories },
    {
      action: 'getPhoneAreaCodeList',
      param: phoneAreaCodeList,
      mapFun: (item) => {
        return {
          ...item,
          label: '+' + item['phoneCode'] + ' ' + item['englishName'],
          value: item.id,
        }
      },
    },
  ].forEach((item) => {
    influencers[item.action]().then((res) => {
      item.param.value = res.data.map((inner) => {
        return item.mapFun
          ? item.mapFun(inner)
          : {
            ...inner,
            label: inner.name,
            value: inner.id,
          }
      })
    })
  })

// 电话号码输入事件，只能输入数字
function handlePhoneNumInput(e) {
  const value = e.target.value

  detail.value.phoneNum = value.replace(/\D/g, '')
}

// 邮箱检测
function checkEmail(e) {
  const val = e.target.value.trim()

  if (!val.length) {
    emailErrorTip.value = 'Email is required.'
  } else if (!/^[\w\d.-]+@[\w\d-]+(?:\.[\w\d-]+)+$/.test(val)) {
    emailErrorTip.value = 'Invalid email, please check again.'
  } else {
    emailErrorTip.value = ''
  }
}

// userName和name为空检测
function checkName(val, type) {
  if (!val.length) {
    if (type == 'name') {
      nameErrorTip.value = 'Name is required.'
    } else {
      userNameErrorTip.value = 'Username is required.'
    }
  } else {
    if (type == 'username' && val.length < 4) {
      userNameErrorTip.value = 'Username must be at least 4 characters long.'

      return
    }

    if (type == 'name') {
      nameErrorTip.value = ''
    } else {
      userNameErrorTip.value = ''
    }
  }
}

// 电话号码时区选择事件
function phoneCodeChange(id, option) {
  countryCallingCode.value = {
    ...option,
    phoneCode: option.label.replace(/(^[\w\W]+?)\s[\w\W]*$/g, '$1'),
  }
}

// 社交平台选择事件
function socialPlatformAdded(id, option) {
  addedSocialPlatforms.value = [
    ...addedSocialPlatforms.value,
    {
      platformId: option.id,
      platformName: option.name,
    },
  ]
  selectedSocialPlatform.value = null
}

// 社交平台删除事件
function deleteSocialPlatform(index) {
  addedSocialPlatforms.value.splice(index, 1)
  console.log(addedSocialPlatforms.value)
}

// 内容分类选择事件
function setSelectedContentCategory(val, option) {
  selectedContentCategory.value = option
}

function save() {
  const data = { ...detail.value }

  Object.keys(data).forEach((key) => {
    if (
      [
        'id',
        'email',
        'gender',
        'userName',
        'name',
        'birthday',
        'contentCategoryId',
        'countryCallingCaodeId',
        'phoneNum',
        'largestSocialAudienceId',
        'primaryAudienceRegionId',
        'note',
        'operatorRemark',
        'linkToolStatus',
        'logInStatus',
        'socialPlatforms',
      ].indexOf(key) == -1
    ) {
      delete data[key]
    }
  })

  if (birthday.value) {
    data['birthday'] = birthday.value.valueOf()
  } else {
    delete data['birthday']
  }
  data['socialPlatforms'] = addedSocialPlatforms.value
  data['contentCategoryId'] = selectedContentCategory.value.id
  data['largestSocialAudienceId'] = selectedLargestSocialAudience.value.id
  data['primaryAudienceRegionId'] = selectedPrimaryAudienceRegion.value.id

  if (data['phoneNum']) {
    data['phoneNumPrefixId'] = countryCallingCode.value.id
  }

  if (emailErrorTip.value.length) {
    message.error(emailErrorTip.value)
    return
  } else if (userNameErrorTip.value.length) {
    message.error(userNameErrorTip.value)
    return
  } else if (nameErrorTip.value.length) {
    message.error(nameErrorTip.value)
    return
  }

  const invalidHomepage = addedSocialPlatforms.value.find((platform) => {
    const homepage = platform.homepage?.trim()
    return homepage && getHomepageValidationHelp(homepage, platform)
  })
  if (invalidHomepage) {
    message.error(
      getHomepageValidationHelp(
        invalidHomepage.homepage.trim(),
        invalidHomepage
      )
    )
    return
  }

  if (
    !emailErrorTip.value.length &&
    !userNameErrorTip.value.length &&
    !nameErrorTip.value.length
  ) {
    isLoading.value = true

    influencers.save(data).then((res) => {
      isLoading.value = false

      if (res.success) {
        message.success('Save successfully.')
      }
    })
  }
}

watch(phoneAreaCodeList, (val) => {
  for (let i = 0, len = val.length; i < len; i++) {
    if (val[i].phoneCode == 1 && val[i].countryCode == 'US') {
      countryCallingCode.value = {
        ...val[i],
        phoneCode: '+1',
      }
    }
  }
})
</script>

<style lang="less" scoped>
.content {
  margin-top: 0;
  min-width: 1100px;
  padding: 20px 20px 0;
}

.basic-info {
  margin: 20px 0 0;
}

.delete {
  right: 0;
  top: -21px;
  color: #ff4d4f;
  position: absolute;
}

.error-tip {
  top: 32px;
  left: 200px;
  color: #ff4d4f;
  position: absolute;
}

.loading {
  width: 100%;
  margin-top: 200px;
  margin-left: -100px;
}

.flex-row {
  text-align: center;

  >span {
    margin-right: 40px;

    &:last-of-type {
      margin-right: 0;
    }
  }
}

.section {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #d9d9d9;

  &:last-of-type {
    border: none;
  }

  >h3 {
    margin: 0 0 20px;
  }

  :deep(.ant) {
    &-row {
      margin: 20px 10px 0 !important;
    }

    &-col {
      display: flex;
      text-align: right;
      align-items: baseline;

      >label {
        flex: 0 0 170px;
        margin-right: 10px;
      }
    }

    &icon-minus-circle {
      top: 1px;
      z-index: 1;
      right: -2px;
      cursor: pointer;
      color: #999;
      position: absolute;

      &:hover {
        color: #ff4d4f;
      }
    }
  }

  .fixed-width {
    flex: 1;
    text-align: left;
  }
}

.flex-wrapper {
  display: flex;
}

.phone-area-code-select {
  margin-right: 6px;
}

.social-platform {
  .platform {
    flex: 1;
    padding: 10px;
    margin-left: 40px;
    border-radius: 6px;
    margin-right: -10px;
    background: #f5f6f7;
  }

  .selected-platform {

    // justify-content: right;
    // &-item {
    //   margin-left: 70px;
    //   border-radius: 6px;
    //   justify-content: right;
    //   background: #f2f2f2;
    //   padding: 10px !important;
    //   max-width: calc(50% - 85px);
    //   .fixed-width {
    //     margin-right: -5px;
    //   }
    // }
    // label {
    //   flex: 0 0 100px;
    // }
    .ant-select {
      text-align: left;
      margin-left: 180px;
    }
  }
}

.operator-mark {
  display: flex;

  >label {
    text-align: right;
    margin-right: 10px;

    >em {
      display: block;
      color: #999;
      margin-top: 5px;
      font-style: normal;
    }
  }
}

.authority {
  display: flex;
  align-items: center;

  >label {
    flex: 1;
    text-align: right;
    margin-right: 10px;
  }

  .fixed-width {
    display: flex;
    align-items: center;

    >label {
      margin-right: 5px;

      &:last-of-type {
        margin-left: 20px;
      }
    }
  }
}

.btns {
  margin-left: 180px;

  .ant-btn-primary {
    margin-right: 20px;
  }
}

.payment-section {
  max-width: 100%;
}

/* 随 Account 列宽铺满单元格，表格宽度由列配置 + scroll.x 撑开 */
.payment-account-text {
  display: block;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.active {
    color: #52c41a;
  }

  &.inactive {
    color: #ff4d4f;
  }
}

.payment-accounts-table {
  width: 100%;

  :deep(.ant-table) {
    .ant-table-cell {
      vertical-align: middle;
    }
  }
}

.tax-section {
  >h3 {
    margin-bottom: 12px;
  }

  .tax-info-card {
    max-width: 720px;
    padding: 20px 24px 24px;
    background: #fff;
    border: 1px solid #ebebeb;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  }

  .tax-info-tin-row {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 8px 16px;
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 1.6;
    color: rgba(0, 0, 0, 0.85);
  }

  .tax-info-label {
    flex: 0 0 auto;
    font-weight: 400;
  }

  .tax-info-tin-value {
    font-weight: 600;
    color: rgba(0, 0, 0, 0.88);
  }

  .tax-info-form-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 12px;
    padding: 12px 16px;
    border: 1px solid #1890ff;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1.5;
  }

  .tax-form-label-inline {
    margin: 0;
  }

  .tax-form-link-wrap {
    flex: 1;
    min-width: 0;
  }

  .required {
    color: #ff4d4f;
    font-style: normal;
    margin-right: 2px;
  }

  .tax-form-link {
    color: #1890ff;
    text-decoration: underline;
    word-break: break-all;

    &:hover {
      color: #40a9ff;
    }
  }

  .tax-form-empty {
    color: rgba(0, 0, 0, 0.45);
  }
}

.empty-text {
  color: #999;
  font-size: 14px;
  line-height: 1.5;
  margin-left: 1em;
}
</style>